module.exports = __webpack_public_path__ + "img/ps.2992f9b9.svg";